import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b3dd650c"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=b3dd650c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3dd650c')) {
      api.createRecord('b3dd650c', component.options)
    } else {
      api.reload('b3dd650c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=b3dd650c", function () {
      api.rerender('b3dd650c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/news/list.vue"
export default component.exports